module.exports = __webpack_public_path__ + "img/月亮日記Logo.f3d79b02.svg";